import NoDataAvailable from './NoDataAvailable';

export default NoDataAvailable;
